<template>
  <header>
    <div class="header-view">
      <div>
        <router-link class="logo-link" :to="routerTo"><img class="logo-img" src="@/assets/logo.jpg"></router-link>
      </div>
      <div class="title">
        <h1>{{ title }}</h1>
      </div>
      <slot></slot>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    routerTo: {
      type: String,
      default: "/"
    },
    title: ""
  }
}
</script>

<style lang="scss" scoped>
.header-view {
  display: flex;
  box-shadow: 0 2px 2px 1px #bbbbbb99;

  .logo-link {
    display: flex;

    .logo-img {
      height: 80px;
    }
  }
}

.title {
  vertical-align: top;
  margin: auto;

  h1 {
    padding: 0px;
    margin: 0px;
  }
}

@media screen and (max-width: 420px) {
  .header-view {
    .logo-link {
      .logo-img {
        height: 40px;
      }
    }
  }
}
</style>